import React, { forwardRef, useContext } from "react";

import { LoginContext } from "src/core/loginContext";

/**
 * Hides the wrapped component when the current
 * user has a read-only role (anything other than
 * ADMIN or READ_WRITE).
 */
export const withReadOnlyGuard = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const Guarded = forwardRef<unknown, P>((props, ref) => {
    const { isReadOnly } = useContext(LoginContext);

    if (isReadOnly) {
      return null;
    }

    return <WrappedComponent {...props} ref={ref} />;
  });

  Guarded.displayName = `withReadOnlyGuard(${
    WrappedComponent.displayName ?? WrappedComponent.name ?? "Component"
  })`;

  return Guarded;
};
